const map = {
	"./1.png": 5110,
	"./10.png": 6596,
	"./2.png": 5437,
	"./3.png": 1540,
	"./4.png": 5403,
	"./5.png": 578,
	"./6.png": 5193,
	"./7.png": 7072,
	"./8.png": 8167,
	"./9.png": 5678
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6021;